export const imageUpload = {
	addImage: "Add image",
	validating: "Validating image...",
	verifyingDimensions: "Checking dimensions and format...",
	removeImage: "Remove uploaded image",
	formatInfo: "JPG or PNG up to {{maxSize}}MB and {{width}}x{{height}}px.",
	ariaLabel: {
		fileInput: "File input for image upload",
		uploadedImage: "Uploaded product image",
		uploadHeading: "Upload heading",
	},
	errors: {
		fileTooLarge: "File too large. Maximum size: {{maxSize}}MB",
		fileInvalidType: "Invalid file type. Use only JPG or PNG.",
		fileDimensionsTooLarge: "Dimensions too large. Maximum: {{width}}x{{height}}px",
		generalError: "Error uploading image",
		validationError: "Error validating image",
		invalidFile: "Invalid file",
	},
};
